import DomHelper from "../helper/DomHelper";
import ErrorCode from "../exception/ErrorCode";
import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {MessageInterface, MessageType} from "./MessageInterface";

/**
 * A Message bundles all the information used in a {@link MessageLog} component.
 */
export default class Message implements MessageInterface, Parameter {
	public id: string;
	public type: MessageType;
	public message: string;
	public date: Date;
	public code?: ErrorCode | number;
	public context?: any;
	public visible: boolean;

	/**
	 * Constructs a {@link Message} instance
	 */
	constructor(message?: string, type?: MessageType, code?: number | ErrorCode) {
		this.id = DomHelper.generateUUID();
		this.type = FunctionHelper.applyValue(type, MessageType.INFO);
		this.message = FunctionHelper.applyValue(message, "");
		this.date = new Date();
		this.visible = true;

		if (FunctionHelper.exists(code)) {
			this.code = code;
		}
	}

	/**
	 * Constructs a {@link Message} instance from a given json structure.
	 */
	public static fromJson(data: any): Message {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		let message: Message = new Message(data.message, data.type, data.code);
		message.id = FunctionHelper.exists(data?.id) ? data.id : message.id;
		message.visible = FunctionHelper.exists(data?.visible) ? data.visible : message.visible;
		message.date = FunctionHelper.exists(data?.date) ? data.date : message.date;
		message.context = FunctionHelper.exists(data?.context) ? data.context : message.context;

		return message;
	}

	/**
	 * returns a json representation of a {@link Message}.
	 */
	public toJson(): any {
		return {
			'id': this.id,
			'type': this.type,
			'message': this.message,
			'visible': this.visible,
			'date': this.date.toISOString(),
			'code': this.code,
			'context': JSON.stringify(this.context)
		};
	}

	/**
	 * Clones and returns this {@link Message}.
	 */
	public clone(): Message {
		return Message.fromJson(this.toJson());
	}
}